// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// for support DirectMessageBase.call(this,... in *.js function class
export const DirectMessageBase = function (code) {
    this.Code = code;
    this.IsDirect = true;
    this.CPHFD = null; // Custom Processing Handler For Delay (return to array)
};

DirectMessageBase.prototype.Clone = function () {
    const newObj = new Object();
    for (const f in this) { newObj[f] = this[f]; }
    return newObj;
};

// for extend DirectMessageBase in *.ts class
export class DirectMessageBaseClass {
    Code: number;
    IsDirect: boolean = true;
    CPHFD: any = null; // Custom Processing Handler For Delay (return to array)

    constructor (code: number) {
        this.Code = code;
    }

    Clone (): any {
        return JSON.parse(JSON.stringify(this));
    }
}
